<div>
  <div class="snackBar">
    <div class="svg-container svg-over">
      <svg width="89" height="86" viewBox="0 0 89 86" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="4" width="82" height="82">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M0 4.48572H81.1666V85.19H0V4.48572Z" fill="white" />
        </mask>
        <g mask="url(#mask0)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M68.5065 25.3155C76.3317 36.0681 82.4118 47.3837 80.948 58.2489C79.4843 69.1142 70.5332 79.5854 59.9494 83.4135C49.3657 87.2417 37.2056 84.4269 25.4396 79.3039C13.7299 74.1809 2.47055 66.7498 0.387578 57.292C-1.75172 47.8341 5.28542 36.2933 13.6173 25.4843C21.9492 14.6191 31.6322 4.48572 41.2589 4.48572C50.9419 4.48572 60.6249 14.6191 68.5065 25.3155Z"
            fill="#193356" />
        </g>
        <mask id="mask1" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="4" width="82" height="82">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M41.2589 4.48572C31.6322 4.48572 21.9492 14.6191 13.6173 25.4843C6.31614 34.9561 0.00940171 44.9899 0 53.6916V53.7295C0.00127863 54.9448 0.125607 56.134 0.387501 57.292C2.47054 66.7498 13.7299 74.181 25.4396 79.3039C37.2056 84.4269 49.3657 87.2417 59.9494 83.4136C70.5331 79.5854 79.4843 69.1142 80.948 58.2489C82.4117 47.3837 76.3316 36.0681 68.5065 25.3155C60.6249 14.6191 50.9419 4.48572 41.2589 4.48572Z"
            fill="white" />
        </mask>
        <g mask="url(#mask1)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M55.9446 52.3105C52.6274 50.7884 50.2904 47.7091 49.7169 44.1047C49.5509 43.0618 49.2345 42.0485 48.7774 41.0965L48.3446 40.1947C47.057 37.5124 46.7171 34.4726 47.3803 31.5721L47.4091 31.5094L48.8084 28.4595C49.039 27.957 48.8809 27.3778 48.4624 27.0526C48.3926 26.9984 48.3177 26.9494 48.2339 26.9109C46.1265 25.9439 43.6291 26.7262 42.4493 28.7223C42.2547 29.0518 42.0635 29.3753 41.8846 29.678C41.2052 30.8278 40.9471 32.1772 41.1538 33.4967L41.8191 37.7443C42.1287 39.7209 40.268 41.3427 38.3522 40.7661L31.0392 38.5646L30.0744 38.2743L26.4174 37.8141C25.4817 37.6962 24.592 38.2526 24.2885 39.1456L23.6079 41.1473C23.3526 41.8979 23.5681 42.7285 24.1562 43.2603L25.1551 44.1635C24.4606 44.0794 23.8148 44.5327 23.6576 45.2143L23.1549 47.3954C23.0284 47.9442 23.2512 48.5146 23.7163 48.8323L24.5546 49.4049L24.5546 49.4049C23.8782 49.3566 23.2782 49.8363 23.1767 50.5069L22.9191 52.2084C22.8324 52.7814 23.1355 53.3426 23.6622 53.5843L24.6467 54.036C24.0621 54.0556 23.5978 54.5341 23.5957 55.1189L23.5898 56.7683C23.5882 57.1947 23.8361 57.5827 24.2237 57.7605L26.6018 58.8517L33.8998 62.2004C36.3376 63.319 39.1023 63.5 41.6651 62.7086C44.2279 61.9173 46.9925 62.0982 49.4304 63.2169L55.2702 66.507L60.5372 55.0284L55.9446 52.3105Z"
            fill="#FFC6C3" />
        </g>
        <mask id="mask2" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="4" width="82" height="82">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M41.2589 4.48572C31.6322 4.48572 21.9492 14.6191 13.6173 25.4843C6.31614 34.9561 0.00940171 44.9899 0 53.6916V53.7295C0.00127863 54.9448 0.125607 56.134 0.387501 57.292C2.47054 66.7498 13.7299 74.181 25.4396 79.3039C37.2056 84.4269 49.3657 87.2417 59.9494 83.4136C70.5331 79.5854 79.4843 69.1142 80.948 58.2489C82.4117 47.3837 76.3316 36.0681 68.5065 25.3155C60.6249 14.6191 50.9419 4.48572 41.2589 4.48572Z"
            fill="white" />
        </mask>
        <g mask="url(#mask2)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M61.266 73.0639L52.8611 68.1705L60.2876 51.9855L69.2643 56.2107L61.266 73.0639Z"
            fill="#E6E6E6" />
        </g>
        <mask id="mask3" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="4" width="82" height="82">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M41.2589 4.48572C31.6322 4.48572 21.9492 14.6191 13.6173 25.4843C6.31614 34.9561 0.00940171 44.9899 0 53.6916V53.7295C0.00127863 54.9448 0.125607 56.134 0.387501 57.292C2.47054 66.7498 13.7299 74.181 25.4396 79.3039C37.2056 84.4269 49.3657 87.2417 59.9494 83.4136C70.5331 79.5854 79.4843 69.1142 80.948 58.2489C82.4117 47.3837 76.3316 36.0681 68.5065 25.3155C60.6249 14.6191 50.9419 4.48572 41.2589 4.48572Z"
            fill="white" />
        </mask>
        <g mask="url(#mask3)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M109.895 96.75L55.4982 70.6812L63.7305 52.6833L119.309 78.0513L109.895 96.75Z"
            fill="#FCCC04" />
        </g>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M83.7956 70.8143C83.7431 70.5917 86.2904 69.094 86.2904 69.094L88.2051 77.539L86.3723 77.9145L83.7956 70.8143Z"
          fill="#193356" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M82.3247 26.3544L84.5888 24.9915L88.205 29.2473L87.6034 30.8718L82.3247 26.3544Z"
          fill="#193356" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M2.20508 66.4344V69.094L8.92547 67.2431V63.2136L2.20508 66.4344Z" fill="#FCCC04" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M69.094 19.8462H71.6256L74.2393 12.2892C74.2393 12.2892 70.9131 10.0874 70.9907 10.3059C71.0724 10.5281 69.094 19.8462 69.094 19.8462Z"
          fill="#FCCC04" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M20.5938 7.67273C20.829 7.67273 22.4349 8.82051 22.4349 8.82051L22.7863 0L19.1111 0.503274L20.5938 7.67273Z"
          fill="#193356" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.64402 19.8462L8.82046 22.3093L2.79313 27.9317C2.79313 27.9317 2.20508 24.093 2.20508 23.8896C2.20508 23.6828 7.64402 19.8462 7.64402 19.8462Z"
          fill="#FCCC04" />
      </svg>
    </div>
    <div class="text-container">
      <div class="title">Merci.</div>
      <div class="message">
        {{ data.message }}
      </div>
      <button mat-icon-button class="close-icon" (click)="close()">
        <mat-icon>cancel</mat-icon>
      </button>
    </div>
  </div>
  <div class="determinate-bar">
    <ng-container *ngIf="indeterminate">
      <mat-progress-bar class="snack-bar-radius" [ngClass]="'primary'" mode="indeterminate"> </mat-progress-bar>
    </ng-container>
    <ng-container *ngIf="!indeterminate">
      <mat-progress-bar class="snack-bar-radius" [ngClass]="'primary'" mode="determinate" [value]="countPercent"> </mat-progress-bar>
    </ng-container>
  </div>
</div>
